import { render } from "./ownerForm.vue?vue&type=template&id=21a0b75e"
import script from "./ownerForm.vue?vue&type=script&lang=js"
export * from "./ownerForm.vue?vue&type=script&lang=js"

import "./ownerForm.vue?vue&type=style&index=0&id=21a0b75e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__